import { render, staticRenderFns } from "./MealButtons.vue?vue&type=template&id=37fad874&scoped=true&"
import script from "./MealButtons.vue?vue&type=script&lang=js&"
export * from "./MealButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fad874",
  null
  
)

export default component.exports